import * as CryptoJS from "crypto-js";

// Secret key for encryption
const _key = "HIDPortal@2025";

// Encrypt function
export const encrypt = (txt: string): string => {
  return CryptoJS.AES.encrypt(txt, _key).toString();
};

// Decrypt function
export const decrypt = (txtToDecrypt: string): string => {
  return CryptoJS.AES.decrypt(txtToDecrypt, _key).toString(CryptoJS.enc.Utf8);
};

// Save encrypted data to localStorage
export const setEncryptedItem = (key: string, value: string): void => {
  const encryptedValue = encrypt(value);
  localStorage.setItem(key, encryptedValue);
};

// Get decrypted data from localStorage
export const getDecryptedItem = (key: string): string | null => {
  const encryptedValue = localStorage.getItem(key);
  return encryptedValue ? decrypt(encryptedValue) : null;
};
